import {
    Box,
    Grid
  } from "@mui/material";
import ProductTable from "../../components/cosmeticRank/trendOliveyoung/ProductTable";
import ProductTrendChart from "../../components/cosmeticRank/trendOliveyoung/ProductTrendChart.jsx";
import ProductPriceTrendChart from "../../components/cosmeticRank/trendOliveyoung/ProductPriceTrendChart.jsx";
import CustomDatePicker from "../../components/CustomDatePicker";
import { CustomMultiSelect } from "../../components/CustomMultiSelect.jsx";
import { CustomRankChangeCell } from "../../components/CustomRankChangeCall.jsx";
import PaginationWithInfo from "../../components/PaginationWithInfo.jsx";
import { useState, useRef, useEffect, useCallback, useMemo} from 'react';
import { useOutletContext } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiDefaultPath.js";
import { backendApiCall } from "../../utils/apiCall.js";


function RankTrendOliveyoung() {

  // 공통 변수
    const today = new Date();

  /**
   * product table 
   **/
    const [selectedTableDate, setSelectedTableDate] = useState(today);
    const [selectedCategoryMain, setSelectedCategoryMain] = useState(["전체"]);
    const [selectedCategoryDepth1, setSelectedCategoryDepth1] = useState(["전체"]);
    const [selectedCategoryDepth2, setSelectedCategoryDepth2] = useState(["전체"]);
    const [selectedBrand, setSelectedBrand] = useState(["전체"]);
    const [selectedRank, setSelectedRank] = useState(["전체"]);
    const [selectedRankChange, setSelectedRankChange] = useState(["전체"]);
    const [selectedProductName, setSelectedProductName] = useState(["전체"]);
    const [selectedTrendProduct, setSelectedTrendProduct] = useState([]);
    const [products, setProducts] = useState([]);
    const inputRefTableDate = useRef();
    const [isLoading, setIsLoading] = useState(true);

    const [isCategoryMainBoxLoading, setIsCategoryMainBoxLoading] = useState(false);
    const [isCategoryDepth1BoxLoading, setIsCategoryDepth1BoxLoading] = useState(false);
    const [isCategoryDepth2BoxLoading, setIsCategoryDepth2BoxLoading] = useState(false);
    const [isBrandBoxLoading, setIsBrandBoxLoading] = useState(false);
    const [isRankBoxLoading, setIsRankBoxLoading] = useState(false);
    const [isRankChangeBoxLoading, setIsRankChangeBoxLoading] = useState(false);
    const [isProductNameBoxLoading, setIsProductNameBoxLoading] = useState(false);

    const [categoryMainOptions, setCategoryMainOptions] = useState([]);
    const [categoryDepth1Options, setCategoryDepth1Options] = useState([]);
    const [categoryDepth2Options, setCategoryDepth2Options] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);
    const [rankOptions, setRankOptions] = useState([]);
    const [rankChangeOptions, setRankChangeOptions] = useState([]);
    const [productNameOptions, setProductNameOptions] = useState([]);
    const [chartProducts, setChartProducts] = useState([]);

    const { token } = useOutletContext();
    // const token = getIdToken(user, true);

    const backendApiCallWithToken = useCallback(
      (apiPath, body, setFn, setLoadingFn) =>
        backendApiCall(apiPath, body, setFn, setLoadingFn, token, API_BASE_URL),
      [token]
    );

    // 테이블 페이징 처리
    const [page, setPage] = useState(0);
    const rowsPerPage = 200; // 고정값
    const paginatedProducts = useMemo(() => {
      const start = page * rowsPerPage;
      return products.slice(start, start + rowsPerPage);
    }, [products, page]);

    // main category 드롭박스 데이터 API 호출
    useEffect(() => {
      backendApiCallWithToken(
          "selectbox/CMain",
          JSON.stringify({
            selectedTableDate: selectedTableDate
          }),
          setCategoryMainOptions,
          setIsCategoryMainBoxLoading
        );
        setSelectedCategoryMain(["전체"]);
    }, [
      backendApiCallWithToken,
      selectedTableDate
    ]);

    // main category sub1 드롭박스 데이터 API 호출
    useEffect(() => {
        if (selectedCategoryMain.length > 0){
          backendApiCallWithToken(
            "selectbox/CDepth1",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain
            }),
            setCategoryDepth1Options,
            setIsCategoryDepth1BoxLoading
          );
          setSelectedCategoryDepth1(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain
    ]);

    // main category sub2 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
        ){
          backendApiCallWithToken(
            "selectbox/CDepth2",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1
            }),
            setCategoryDepth2Options,
            setIsCategoryDepth2BoxLoading
          );
          setSelectedCategoryDepth2(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain,
      selectedCategoryDepth1
    ]);

    // brand 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
          && selectedCategoryDepth2.length > 0
        ){
          backendApiCallWithToken(
            "selectbox/Brand",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1,
              selectedCategoryDepth2: selectedCategoryDepth2
            }),
            setBrandOptions,
            setIsBrandBoxLoading
          );
          setSelectedBrand(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain,
      selectedCategoryDepth1,
      selectedCategoryDepth2
    ]);

    // rank 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
          && selectedCategoryDepth2.length > 0
          && selectedBrand.length > 0
        ){
          backendApiCallWithToken(
            "selectbox/Rank",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1,
              selectedCategoryDepth2: selectedCategoryDepth2,
              selectedBrand: selectedBrand
            }),
            setRankOptions,
            setIsRankBoxLoading
          );
          setSelectedRank(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain,
      selectedCategoryDepth1,
      selectedCategoryDepth2,
      selectedBrand
    ]);

    // 순위추이 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
          && selectedCategoryDepth2.length > 0
          && selectedBrand.length > 0
          && selectedRank.length > 0
        ){
          backendApiCallWithToken(
            "selectbox/RankChange",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1,
              selectedCategoryDepth2: selectedCategoryDepth2,
              selectedBrand: selectedBrand,
              selectedRank: selectedRank,
            }),
            setRankChangeOptions,
            setIsRankChangeBoxLoading
          );
          setSelectedRankChange(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain,
      selectedCategoryDepth1,
      selectedCategoryDepth2,
      selectedBrand,
      selectedRank
    ]);

    // 상품명 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
          && selectedCategoryDepth2.length > 0
          && selectedBrand.length > 0
          && selectedRank.length > 0
          && selectedRankChange.length > 0
        ){
          backendApiCallWithToken(
            "selectbox/ProductName",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1,
              selectedCategoryDepth2: selectedCategoryDepth2,
              selectedBrand: selectedBrand,
              selectedRank: selectedRank,
              selectedRankChange: selectedRankChange
            }),
            setProductNameOptions,
            setIsProductNameBoxLoading
          );
          setSelectedProductName(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryMain,
      selectedCategoryDepth1,
      selectedCategoryDepth2,
      selectedBrand,
      selectedRank,
      selectedRankChange
    ]);

    // 상품리스트 테이블 데이터 API 호출
    useEffect(() => {
      setSelectedTrendProduct([]);
        if (
          selectedCategoryMain.length > 0
          && selectedCategoryDepth1.length > 0
          && selectedCategoryDepth2.length > 0
          && selectedBrand.length > 0
          && selectedRank.length > 0
          && selectedRankChange.length > 0
          && selectedProductName.length > 0
        ){
          backendApiCallWithToken(
            "products", 
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryMain: selectedCategoryMain,
              selectedCategoryDepth1: selectedCategoryDepth1,
              selectedCategoryDepth2: selectedCategoryDepth2,
              selectedRank: selectedRank,
              selectedBrand: selectedBrand,
              selectedRankChange: selectedRankChange,
              selectedProductName: selectedProductName
            }),
            setProducts,
            setIsLoading
          );
        }
        setPage(0);
    }, [
      backendApiCallWithToken,
      selectedTableDate, 
      selectedCategoryMain, 
      selectedCategoryDepth1, 
      selectedCategoryDepth2,
      selectedBrand,
      selectedRank,
      selectedRankChange,
      selectedProductName
    ]);

    // 상품에 대한 추이 그래프 이벤트
    const toggleProduct = (product) => {
      const isSelected = selectedTrendProduct.find((p) => p.ProductName === product.ProductName);
      if (isSelected) {
        setSelectedTrendProduct(selectedTrendProduct.filter((p) => p.ProductName !== product.ProductName));
      } else {
        setSelectedTrendProduct([...selectedTrendProduct, product]);
      }
    };
  
  /**
   * trend chart
   */
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    const [selectedChartStartDate, setSelectedChartStartDate] = useState(sevenDaysAgo);
    const [selectedChartEndDate, setSelectedChartEndDate] = useState(today);
    const [isChartLoading, setIsChartLoading] = useState(false);

    // 상품에 대한 추이 그래프 API 호출
    useEffect(() => {
      if (selectedTrendProduct.length > 0){
        backendApiCallWithToken(
            "chart", 
            JSON.stringify({
              startDate: selectedChartStartDate,
              endDate: selectedChartEndDate,
              selectedProducts: selectedTrendProduct,
            }),
            setChartProducts,
            setIsChartLoading
          );
        }
    }, [
      backendApiCallWithToken,
      selectedChartStartDate, 
      selectedChartEndDate, 
      selectedTrendProduct
    ]);

  return (
    <div>
      <Box display="flex" gap={2}>
        <Box sx={{ px: 0, py: 0 }}>
          {/* 검색창 공간 확보용 */}
          <Box
            width="800px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            border="1px solid #e0e0e0"
            borderBottom="none"
            borderRadius="8px 8px 0 0"
            position="sticky"
            top={0}
            zIndex={2}
            bgcolor="#fff"
          >
            <Box>
              <Grid container spacing={0.3}>
                {/* 날짜 필터 */}
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker 
                    selectedDate={selectedTableDate}
                    setSelectedDate={setSelectedTableDate}
                    inputRef={inputRefTableDate}
                    label="조회 기준일"
                  />
                </Grid>
                {/* 카테고리 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCategoryMainBoxLoading ? 0.4 : 1,
                      pointerEvents: isCategoryMainBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="카테고리 메인"
                      labelId="main-category-1"
                      optionItems={categoryMainOptions}
                      selectedValue={selectedCategoryMain}
                      onChange={setSelectedCategoryMain}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 상세 카테고리1 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCategoryDepth1BoxLoading ? 0.4 : 1,
                      pointerEvents: isCategoryDepth1BoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="카테고리 중분류"
                      labelId="deatil-category-1st"
                      optionItems={categoryDepth1Options}
                      selectedValue={selectedCategoryDepth1}
                      onChange={setSelectedCategoryDepth1}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 상세 카테고리2 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCategoryDepth2BoxLoading ? 0.4 : 1,
                      pointerEvents: isCategoryDepth2BoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="카테고리 소분류"
                      labelId="deatil-category-2st"
                      optionItems={categoryDepth2Options}
                      selectedValue={selectedCategoryDepth2}
                      onChange={setSelectedCategoryDepth2}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 브랜드 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isBrandBoxLoading ? 0.4 : 1,
                      pointerEvents: isBrandBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="브랜드"
                      labelId="brand-1st"
                      optionItems={brandOptions}
                      selectedValue={selectedBrand}
                      onChange={setSelectedBrand}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 순위 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isRankBoxLoading ? 0.4 : 1,
                      pointerEvents: isRankBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="순위"
                      labelId="rank-"
                      optionItems={rankOptions}
                      selectedValue={selectedRank}
                      onChange={setSelectedRank}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 순위 변동 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isRankChangeBoxLoading ? 0.4 : 1,
                      pointerEvents: isRankChangeBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="순위 변동"
                      labelId="rank-chan-"
                      optionItems={rankChangeOptions}
                      selectedValue={selectedRankChange}
                      onChange={setSelectedRankChange}
                      CustomRankChangeCell={CustomRankChangeCell}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 상품명 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isProductNameBoxLoading ? 0.4 : 1,
                      pointerEvents: isProductNameBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                      paddingTop: "10px"
                    }}
                  >
                    <CustomMultiSelect
                      label="상품명"
                      labelId="product"
                      optionItems={productNameOptions}
                      selectedValue={selectedProductName}
                      onChange={setSelectedProductName}
                      width="765px"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box
            width="800px"
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderTop: "none", // 여기 핵심
              borderRadius: "0 0 8px 8px",
              // maxHeight: "50vh",
              height: "745px",
              overflowY: "auto",
              overflowX: 'hidden'
            }}
          >
            {/* 상품 테이블 */}
            <ProductTable
              products={paginatedProducts}
              selectedProducts={selectedTrendProduct}
              onToggle={toggleProduct}
              checkoutToggleAll={setSelectedTrendProduct}
              isLoading={isLoading}
              CustomRankChangeCell={CustomRankChangeCell}
            />
          </Box>
          {/* 페이징 처리 */}
          <PaginationWithInfo 
            totalCount={products.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            isLoading={isLoading}
          />
        </Box>
        <Box sx={{px: 0, py: 0}}>
          <Box
            sx={{
              width: "750px",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              mt: 0
            }}
          >
            {/* 상단 검색창/타이틀 영역 */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
              borderBottom="1px solid #e0e0e0"
              bgcolor="#fff"
            >
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                    transition: "opacity 0.3s ease",
                    pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                  }}
                >
                  <CustomDatePicker 
                    selectedDate={selectedChartStartDate}
                    setSelectedDate={setSelectedChartStartDate}
                    inputRef={inputRefTableDate}
                    label="시작일"
                  />
                  <CustomDatePicker 
                    selectedDate={selectedChartEndDate}
                    setSelectedDate={setSelectedChartEndDate}
                    inputRef={inputRefTableDate}
                    label="종료일"
                  />
                </Box>
              </Grid>
            </Box>
            {/* 그래프 영역 */}
            <Box sx={{ p: 2, bgcolor: "#fff" }}>
              <Box
                sx={{
                  opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                  transition: "opacity 0.3s ease",
                  pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                }}
              >
                <ProductTrendChart 
                  selectedChartStartDate={selectedChartStartDate}
                  selectedChartEndDate={selectedChartEndDate}
                  selectedTrendProduct={selectedTrendProduct}
                  chartProducts={chartProducts} 
                />
              </Box>
            </Box>
            <Box sx={{ p: 2, bgcolor: "#fff" }}>
              <Box
                sx={{
                  opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                  transition: "opacity 0.3s ease",
                  pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                }}
              >
                <ProductPriceTrendChart 
                  selectedChartStartDate={selectedChartStartDate}
                  selectedChartEndDate={selectedChartEndDate}
                  selectedTrendProduct={selectedTrendProduct}
                  chartProducts={chartProducts} 
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default RankTrendOliveyoung;
